export const setDocumentModels = (models) => ({
  type: 'SET_DOCUMENT_MODELS',
  payload: models,
});